import { cyberpunkTheme } from '../../styles/theme'

export default function Disclaimer() {
  const t = cyberpunkTheme.colors
  return (
    <footer
      style={{
        marginTop: 'auto',
        padding: 'clamp(0.6rem, 2vw, 0.85rem) clamp(0.75rem, 3vw, 1.25rem)',
        textAlign: 'center',
        fontSize: '0.4rem',
        lineHeight: 2,
        color: t.text.muted,
        borderTop: `2px solid ${t.border.default}`,
        background: 'rgba(0,0,0,0.3)',
        fontFamily: cyberpunkTheme.fonts.display,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.5rem',
      }}
    >
      <a
        href="#/whitepaper"
        style={{
          color: t.primary,
          textDecoration: 'none',
          fontSize: '0.45rem',
          letterSpacing: '0.05em',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.textDecoration = 'underline'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.textDecoration = 'none'
        }}
      >
        WHITEPAPER
      </a>
      PLAY AT YOUR OWN RISK. ENTRY FEES NON-REFUNDABLE EXCEPT ON CANCEL. NOT FINANCIAL ADVICE.
    </footer>
  )
}
